import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Grid, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EventsMetricCard from './widgets/EventsMetricCard';
import EventsListSection from './widgets/EventsListSection';
import { useEventMetricsQuery } from '../../api/use-event-metrics-query';
import { useEventsScope } from '../../contexts/EventsScopeContext';
import { buildEventsSummaryMetrics } from './eventsMetrics';
import { PortalPageHeader } from '../layout/PortalPageHeader';

const Events = () => {
  const navigate = useNavigate();
  const { routes, features } = useEventsScope();

  const { data: eventMetrics = null, isLoading: isLoadingMetrics } = useEventMetricsQuery();

  const summaryMetrics = useMemo(() => buildEventsSummaryMetrics(eventMetrics), [eventMetrics]);

  const handleAddEvent = () => {
    navigate(routes.new);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <PortalPageHeader title="Events" />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAddEvent}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '20px',
            px: 2.5,
            py: 1,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          Add New Event
        </Button>
      </Box>

      {features.showMetrics && isLoadingMetrics && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.secondary">
            Loading event metrics...
          </Typography>
        </Box>
      )}

      {features.showMetrics && (
        <Grid container spacing={2.5} sx={{ mb: 0 }}>
          {summaryMetrics.map((metric) => (
            <Grid item xs={12} sm={6} md={4} key={metric.id}>
              <EventsMetricCard
                label={metric.label}
                value={metric.value}
                tooltip={metric.tooltip}
                valuePrefix={metric.valuePrefix}
                formatValue={metric.formatValue}
              />
            </Grid>
          ))}
        </Grid>
      )}

      <EventsListSection />
    </Box>
  );
};

export default Events;
